import dayjs from 'dayjs';
import { action as mobxAction } from 'mobx';
import React from 'react';
import { Action } from '~/lib/ApiModel';
import { getAppContext } from '~/lib/AppContext';
import ActionErrorMessage from './ActionErrorMessage';

/** Shows the toast announcing that an action has completed or failed. */
export const notifyActionFinished = mobxAction((action: Action) => {
    const notify = getAppContext().notify;
    if (action.status === 'errored') {
        notify.fire({
            color: 'danger',
            title: `${action.title} Failed`,
            body: <ActionErrorMessage errorMessage={action.error_message} />,
            timeout: 0,
        });
        return;
    }

    if (action.status === 'completed') {
        const start = dayjs(action.started_at);
        const finish = dayjs(action.completed_at);
        const hours = finish.diff(start, 'h');
        const mins = finish.diff(start, 'm') % 60;
        const secs = finish.diff(start, 's') % 60;

        notify.fire({
            color: 'success',
            title: `${action.title}`,
            body: (
                <span>
                    {action.title} completed in {hours ? `${hours}h ` : ''}
                    {mins ? `${mins}m ` : ''}
                    {secs ? `${secs}s` : ''}
                </span>
            ),
        });
    }
});
